export default __webpack_public_path__ + "static/media/mb-logo.fce92c23.png";